<div class="toggle">
    <div class="toggle-action" (click)="decrement()" id="decrementer" [ngClass]="{'disabled': value === floor}">
        <div class="toggle-action-media">
            <ng-content select="[decrementer]"></ng-content>
        </div>
    </div>
    <div class="toggle-value">
        <div class="toggle-value-title">
            {{value}}
        </div>
    </div>
    <div class="toggle-action" (click)="increment()" id="incrementer" [ngClass]="{'disabled': value === limit}">
        <div class="toggle-action-media">
            <ng-content select="[incrementer]"></ng-content>
        </div>
    </div>
</div>
<div class="value" *ngIf="!hideLimit">
    <div class="value-title">
        {{limit}}
    </div>
</div>
